export class GroupReportTest {
    title?: string;
    result?: number;

    static fromJson(fields: any): GroupReportTest {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
